import React from "react";
import { CONSISTENCY } from "../../landingContent";

const CONSISTENCY_CHECK_INITIAL_DELAY_MS = 350;
const CONSISTENCY_CHECK_LINE_OFFSET_MS = 900;
const MOBILE_CONSISTENCY_QUOTE =
  "My students know where to look, what's coming next, and how much time they have left — which means fewer interruptions, smoother transitions, and less stress for me.";

const getConsistencyCheckDelayMs = (lineIndex) => (
  CONSISTENCY_CHECK_INITIAL_DELAY_MS + (lineIndex * CONSISTENCY_CHECK_LINE_OFFSET_MS)
);

const ConsistencySection = () => (
  <section className="landing-v2__section landing-v2__section--muted" aria-labelledby="consistency-heading">
    <div className="landing-v2__container">
      <div className="landing-v2-consistency__intro-panel">
        <div className="landing-v2-consistency__intro landing-v2__split">
          <div className="landing-v2-consistency__headline-col">
            <h2 id="consistency-heading" className="landing-v2-consistency__headline landing-v2__heading">
              {CONSISTENCY.headlinePhrases.map((phrase, lineIndex) => (
                <span key={phrase} className="landing-v2-consistency__headline-line">
                  <span
                    className="landing-v2-consistency__check"
                    aria-hidden="true"
                    style={{ "--check-delay": `${getConsistencyCheckDelayMs(lineIndex)}ms` }}
                  >
                    <i className="fa fa-check" />
                  </span>
                  <span className="landing-v2-consistency__headline-text">{phrase}</span>
                </span>
              ))}
            </h2>
          </div>
          <div className="landing-v2-consistency__copy-col">
            <p className="landing-v2-consistency__subheading">
              {CONSISTENCY.paragraph}
            </p>
          </div>
        </div>
      </div>

      <figure className="landing-v2-consistency__quote-card">
        <div className="landing-v2-consistency__quote-mark" aria-hidden="true">
          &ldquo;
        </div>
        <blockquote className="landing-v2-consistency__quote">
          <span className="landing-v2-consistency__quote-desktop">
            {CONSISTENCY.testimonial.quote}
          </span>
          <span className="landing-v2-consistency__quote-mobile">
            {MOBILE_CONSISTENCY_QUOTE}
          </span>
        </blockquote>
        <div className="landing-v2-consistency__quote-mark landing-v2-consistency__quote-mark--close" aria-hidden="true">
          &rdquo;
        </div>
      </figure>
    </div>
  </section>
);

export default ConsistencySection;
